
// 🛡️ [SECURITY & COMPATIBILITY SHIM]
// Prevents "process is not defined" Uncaught errors in browser-side module execution.
// Essential for Gemini SDK which checks for process.env.
if (typeof window !== 'undefined' && !Reflect.has(window, 'process')) {
  Object.defineProperty(window, 'process', {
    configurable: true,
    enumerable: false,
    value: {
      env: {
        NODE_ENV: import.meta.env.MODE || 'development',
        GEMINI_API_KEY: import.meta.env.VITE_GEMINI_API_KEY || '',
      },
    },
    writable: false,
  });
}

export {};
